import { AfterViewInit, Component, Input, OnChanges, OnInit, Renderer2, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { SharerService } from 'src/app/services/sharer.service';
import { TaskService } from 'src/app/services/task.service';
import { UserMasterService } from 'src/app/services/user-master.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-sharer-user-list',
  templateUrl: './sharer-user-list.component.html',
  styleUrls: ['./sharer-user-list.component.css']
})
export class SharerUserListComponent implements OnInit, OnChanges, AfterViewInit {

  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtSharerList: DataTables.Settings = {};
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  
  @ViewChild(DataTableDirective)
  dtElementForUPSISharer: DataTableDirective;
  dtOptionsForUPSISharer: DataTables.Settings = {};
  dtTriggerForUPSISharer: Subject<any> = new Subject();

  @Input('typeOfUserList') typeOfUserList: any;
  @Input('sharerId') sharerId: any;
  selectedUser: any;
  errorMessage: boolean;
  internalUser: any =[];
  UPSIUserList: any =[];
  SharedIdView:any;
  constructor(private taskService: TaskService, private sharesrService: SharerService, 
    public activeModal: NgbActiveModal, private renderer: Renderer2, private userMasterService: UserMasterService) { }

  ngOnInit() {
    this.dtOptions = {
      processing: true,
      serverSide: false,
      scrollX: true,
      deferRender: true,
      stateSave: true,
      stateDuration: -1,
      scrollY: "420px",
      scrollCollapse: true,
      destroy: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'asc'],
      columnDefs: [{ orderable: false, targets: [0] }],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
    }
    this.errorMessage = false;
    var userLogin = JSON.parse(localStorage.getItem("user"));
    this.SharedIdView = userLogin._id
    console.log('this.typeOfUser', this.typeOfUserList)
    if (this.typeOfUserList == 'govevaUser') {
      // Use UserMasterService to get all users including unauthorized ones
      this.userMasterService.getAllUserList().subscribe(response => {
        console.log('goveva User list', response)
        // Include all users regardless of authorization status (both authorized and unauthorized)
        let cloneUserList = Object.assign([], response.result || [])
        // Include authorized/unauthorized active users; exclude Super Admin and deactive users
        let allUsers = cloneUserList.filter((user) => {
          return user != null && user != undefined && !this.isExcludedSharerUser(user);
        });
        let self = this;
        for(let index = 0; index < _.size(allUsers); index++) {
          if(self.sharerId == allUsers[index]._id || allUsers[index]._id == this.SharedIdView) {
            allUsers[index].IsSelected = true
          } else {
            allUsers[index].IsSelected = false
          }
        }
        this.internalUser = allUsers
        this.dtTrigger.next();
      })
      // let companyDetails = localStorage.getItem("companyDetailsGoveva")
      
    } else {

      this.dtOptionsForUPSISharer = {
        processing: true,
        serverSide: false,
        scrollX: true,
        deferRender: true,
        stateSave: true,
        stateDuration: -1,
        scrollY: "420px",
        scrollCollapse: true,
        destroy: true,
        pagingType: 'full_numbers',
        paging: true,
        pageLength: 10,
        search: true,
        // order: [0, 'asc'],
        // columnDefs: [{ orderable: false, targets: [5] }],
        lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      }
      var companyDetails =  JSON.parse(localStorage.getItem("companyDetails"));
    
      var paramData = {
        companyID : companyDetails.companyID
      }
      
      this.sharesrService.getSharerList(paramData).subscribe((response:any) => {
        console.log('get non goveva user list', response.data)
        let cloneOfSharer = Object.assign([], response.data)
        cloneOfSharer = cloneOfSharer.filter((user) => !this.isExcludedSharerUser(user));
        let self = this;
        for(let index=0; index < _.size(cloneOfSharer); index++) {
          if(self.sharerId == cloneOfSharer[index]._id) {
            cloneOfSharer[index].IsSelected = true
            self.selectedUser = cloneOfSharer[index]._id
            self.errorMessage = false
          } else {
            cloneOfSharer[index].IsSelected = false
          }
        }
        this.UPSIUserList = cloneOfSharer;
        this.dtTriggerForUPSISharer.next();
      })
     
    }
  }

  ngOnChanges() {

  }

  ngAfterViewInit(): void {
    this.renderer.listen('document', 'click', (event) => {
      if (event.target.hasAttribute("select_user")) {
        console.log('chekcing for the full_id', event.target.attributes.select_user.value)
        this.selectedUser = event.target.attributes.select_user.value
        this.errorMessage = false
      }


    });
  }

  selectedSharerUser(userDetail) {
    console.log(userDetail)
  }

  save() {
    if (_.size(this.selectedUser)) {
      this.activeModal.close(this.selectedUser)
    } else {
      this.errorMessage = true;
    }
  }

  cancel() {
    this.activeModal.dismiss('dismiss')
  }

  selectUser($event, id, indexOfUser) {
    console.log("test")
    let self = this;
    if(this.typeOfUserList == 'govevaUser') {
      for (let index = 0; index < _.size(self.internalUser); index++) {
        if(index == indexOfUser) {
          self.internalUser[indexOfUser].IsSelected = $event.target.checked
          if($event.target.checked) {
            this.selectedUser = id      
          } else {
            this.selectedUser = null
          }
        } else {
          self.internalUser[index].IsSelected = false
        }
      }
    } else {
      for(let index = 0; index < _.size(self.UPSIUserList); index++){
        if(index == indexOfUser) {
          self.UPSIUserList[indexOfUser].IsSelected = $event.target.checked
          if($event.target.checked) {
            this.selectedUser = id      
          } else {
            this.selectedUser = null
          }
        } else {
          self.UPSIUserList[index].IsSelected = false
        }
      }
    }
    // this.selectedUser = id
    this.errorMessage = false
  }

  private isExcludedSharerUser(user: any): boolean {
    if (!user) {
      return true;
    }

    if (user.IsActive === false || user.isActive === false) {
      return true;
    }

    const email = (user.EmailId || user.email_id || '').toLowerCase().trim();
    if (email === 'superadmin@gmail.com') {
      return true;
    }

    const typeOfUser = (user.TypeOfUser || '').toLowerCase();
    if (typeOfUser === 'superadmin') {
      return true;
    }

    const designation = (user.Designation || '').toLowerCase();
    if (designation === 'superadmin') {
      return true;
    }

    const roles = user.Roles;
    if (Array.isArray(roles)) {
      return roles.some((role: any) => {
        const roleName = (typeof role === 'string' ? role : role?.RoleName || '').toLowerCase();
        return roleName === 'superadmin' || roleName === 'guestsuperadmin';
      });
    }

    if (typeof roles === 'string') {
      return roles.toLowerCase().includes('superadmin');
    }

    return false;
  }

}
